import styled from "styled-components";
import IconButton from "common/Buttons/IconButton";
import Badge from "antd/es/badge";
import { ReactNode } from "react";

interface HeaderIconWithBadgeProps {
  icon: ReactNode;
  counterColor: string;
  counterText: string;
  oneDigit?: boolean;
  showCounter?: boolean;
  isActive: boolean;
}

const HeaderIconWithBadge = ({
  icon,
  counterColor,
  counterText,
  oneDigit,
  showCounter,
  isActive,
}: HeaderIconWithBadgeProps) => {
  return (
    <Badge
      count={
        <Counter $counterColor={counterColor} $oneDigit={oneDigit}>
          {counterText}
        </Counter>
      }
      offset={[oneDigit ? -18 : -14, 12]}
      style={{ display: showCounter ? "flex" : "none" }}
    >
      <IconButton icon={icon} isActive={isActive} />
    </Badge>
  );
};

export default HeaderIconWithBadge;

export const Counter = styled.div<{
  $counterColor: string;
  $oneDigit?: boolean;
}>`
  width: ${(p) => (p.$oneDigit ? "14px" : "auto")};
  height: 16px;
  background: ${(p) => p.$counterColor};
  color: ${(p) => p.theme.colors.white};
  font-size: 11px;
  border-radius: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  user-select: none;
`;
